import { Suspense } from 'react';

import { useScript } from '@twiliointernal/e2-commons-shared-hooks';

import { SupportApi } from '@twiliointernal/e2-commons-shared-api';
import {
  getOscConfig,
  getRealm,
  Hostname,
  Realm,
} from '@twiliointernal/e2-commons-shared-definitions';
import { logger, LoggerTypes } from '@twiliointernal/e2-commons-shared-libs';

import { AppProvider } from './providers';
import { initializeRum } from '../lib/rum';

const { realm, recaptchaSiteKey } = getOscConfig();

initializeRum();

// Initialize Logger
const twilioRealm = getRealm(window.location.hostname as Hostname) || 'prod';
logger._initializeLogger({
  env: twilioRealm,
  service: LoggerTypes.LoggerDataDogServices.OneSupportCenter,
});

// Inject Logger after DD initialization
SupportApi.setLogger(logger);

export default (): JSX.Element => {
  // Disable TrustArc in pre-prod environments
  const isTrustArcDisabled = realm !== Realm.prod;
  // Load TrustArc site wide - https://www.trustarc.com/cookie-consent-manager/
  useScript({
    src: 'https://consent.trustarc.com/notice?domain=twilio.com&c=teconsent&gtm=1&js=nj&noticeType=bb',
    disabled: isTrustArcDisabled,
  });
  // Load reCaptcha site wide - https://developers.google.com/recaptcha/docs/v3#placement_on_your_website
  useScript({
    src: `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}&badge=bottomleft`,
  });

  return (
    <Suspense fallback={null}>
      <AppProvider />
    </Suspense>
  );
};
